import { render } from "./CreateCompanyRadioCardGroup.vue?vue&type=template&id=2f8619f1"
import script from "./CreateCompanyRadioCardGroup.vue?vue&type=script&lang=js"
export * from "./CreateCompanyRadioCardGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__